import React, { useMemo } from 'react'
import { ImageVideoSliderProps } from './types'
import { BlogMediaCaption, BlogMediaCopyright, BlogMediaElement } from '../../components/Blog/MediaElement'
import { Swiper as SwiperInstance, SwiperOptions } from 'swiper'
import { Button } from '../../components/UI'
import {
  ImageVideoCaptionContainer,
  ImageVideoSliderNavigation,
  ImageVideoWrapper,
  StyledImageVideoFooter,
  StyledImageVideoMediaFigure,
  StyledImageVideoSwiper,
  StyledSwiperSlide,
} from './styled'

export const ImageVideoSlider = ({ blok }: ImageVideoSliderProps) => {
  const [swiper, setSwiper] = React.useState<SwiperInstance | null>(null)
  const [currentSlide, setCurrentSlide] = React.useState(0)
  const swiperOptions: SwiperOptions = {
    spaceBetween: 20,
    speed: 600,
  }

  const renderImageVideoElement = useMemo(() => {
    return (filename: string) => {
      return (
        <StyledImageVideoMediaFigure>
          <BlogMediaElement mediaSrc={filename} isVideo={true} alt={blok.alt} title={blok.title} />
        </StyledImageVideoMediaFigure>
      )
    }
  }, [blok.alt, blok.title])


  return (
    <ImageVideoWrapper>
      <StyledImageVideoSwiper
        onSwiper={swiper => setSwiper(swiper)}
        onSlideChange={swiper => {
          setCurrentSlide(swiper.activeIndex)
        }}
        {...swiperOptions}
      >
        {blok?.assets?.map((asset, index) => {
          const { copyright, source } = asset
          const copyRightAndSource: string[] = []
          if (copyright) {
            copyRightAndSource.push(`© ${copyright}`)
          }

          if (source) {
            copyRightAndSource.push(source)
          }
          return (
            <StyledSwiperSlide key={`${asset.filename}-${index}`}>
              {renderImageVideoElement(asset.filename)}
            </StyledSwiperSlide>
          )
        })}
      </StyledImageVideoSwiper>
      <ImageVideoSliderNavigation>
        <ImageVideoCaptionContainer>
          {blok?.assets?.map((asset, index) => {
            const { copyright, source, title } = asset
            const mediaCaption = title
            const copyRightAndSource: string[] = []
            if (copyright) {
              copyRightAndSource.push(`© ${copyright}`)
            }

            if (source) {
              copyRightAndSource.push(source)
            }
            return (
              <StyledImageVideoFooter key={`caption-${asset.filename}-${index}`} $show={currentSlide === index}>
                <BlogMediaCaption>{mediaCaption}</BlogMediaCaption>
                <BlogMediaCopyright>{copyright}</BlogMediaCopyright>
              </StyledImageVideoFooter>
            )
          })}
        </ImageVideoCaptionContainer>
        <div>
          <Button
            $size="small"
            $variant="tertiary"
            onClick={() => swiper && swiper.slidePrev(200, true)}
            iconLeft="arrow-left"
            $ignoreTheme
          />
          <Button
            $size="small"
            $variant="tertiary"
            onClick={() => swiper && swiper.slideNext()}
            iconLeft="arrow-right"
            $ignoreTheme
          />
        </div>
      </ImageVideoSliderNavigation>
    </ImageVideoWrapper>
  )
}
